/**
 * 初始化文章页面的 'See The Set' 轮播图
 */
document.addEventListener('DOMContentLoaded', () => {
  const articleSwiper = document.querySelector('.article-see-the-set-swiper');
  if (articleSwiper) {
    new Swiper(articleSwiper, {
      loop: true,
      slidesPerView: window.innerWidth < 768 ? 2 : 4,
      spaceBetween: window.innerWidth < 768 ? 10 : 20,
      slidesPerGroup: 2,
      navigation: {
        nextEl: articleSwiper.querySelector('.swiper-button-next'),
        prevEl: articleSwiper.querySelector('.swiper-button-prev'),
      },
    });
  }
});